import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function usePreemptions(parameters: Record<string, string>, enabled: boolean) {
  return useQuery({
    queryKey: ["preemptions", parameters],
    queryFn: () => api.getPreemptions(parameters),
    enabled,
    placeholderData: keepPreviousData,
  });
}
